import { AfterViewInit, Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';
import { MibpToastItem } from 'root/shared/services/toast-service/toast.service.interface';
import { ToastType } from 'root/shared/services/toast-service/toast.enum';


export interface ToastButton {
  id: string;
  textResourceString: string;
}

@Component({
  selector: 'mibp-toast',
  styleUrls: ['./toast.component.scss'],
  templateUrl: './toast.component.html',
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, ResourceStringComponent]
})
export class MibpToastComponent implements AfterViewInit {
  @Input({ required: true }) toast: MibpToastItem;
  @Output() dismiss = new EventEmitter<number>();
  @Output() action = new EventEmitter<{ toastId: number; button: ToastButton }>();
  @Output() shown = new EventEmitter<number>();

  readonly ToastType = ToastType;

  ngAfterViewInit(): void {
    this.shown.emit(this.toast.id);
  }

  activate(button: ToastButton): void {
    this.action.emit({ toastId: this.toast.id, button });
  }
}
